<template>
  <div class="about">
    <div id="myMap" ref="chart"></div>
    <el-button
      type="primary"
      size="mini"
      title="点击返回上一级"
      class="btn"
      @click="upside"
      >{{ adName }}</el-button
    >

    <!-- 添加企业列表图标 -->
    <template v-if="currentDataList.length">
      <div
        v-if="!showCompanyList"
        class="company-list-icon"
        @click="toggleCompanyList"
      >
        <span>企业合集</span>
      </div>

      <!-- 添加企业列表容器 -->
      <div v-else class="company-list-container" v-show="showCompanyList">
        <div class="company-list-header">
          <span>企业列表</span>
          <img
            src="~@/assets/recycling/echartsMap/close.svg"
            @click="toggleCompanyList"
            alt="关闭"
          />
        </div>
        <div class="company-list-content">
          <div
            v-for="(company, index) in currentDataList"
            :key="index"
            class="company-item"
            :class="choseComponyName === company.name ? 'choseColor' : ''"
            :title="company.name"
            @click="showCompanyDetail(company)"
          >
            {{ company.name }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import axios from 'axios';
import { isPointInMultiPolygon } from '@/util/echartTool.js';
import iconUrl from '@/assets/recycling/echartsMap/close.svg';
import Store from '@/store/index.js';
import mockData from './mockData';
import allAdcode from './json/allAdcode.json';
import centroidList from '@/util/centroidList.json';
import allCentrids from '@/util/allCentrids.json';
import cityScale from './json/cityScale.json';
import { dom1, dom2 } from './dom';
import {
  getAmountOfDismantling,
  getStatiosTypedata,
  getPointList,
  getComponyInfomation,
} from '@/API/echarts/echarts';
import { AlarmClock } from '@element-plus/icons-vue';
import * as echarts from "echarts";
let myChartMap = null; //地图
let charTimer = null; // 点位轮播
const that = this; // 保存 this 引用

let companyUrl = require('../../../public/home/compony.svg');
export default {
  name: 'about',
  components: { AlarmClock },
  data() {
    return {
      mapPointArr: '',
      timer: '',
      optionMap: {
        //地理坐标系组件
        tooltip: {
          show: true, //是否显示提示框组件，包括提示框浮层和 axisPointer。
          trigger: 'item', //触发类型。item,axis,none
          enterable: true, //鼠标是否可进入提示框浮层中，默认为false，
          showContent: true, //是否显示提示框浮层
          triggerOn: 'click', //提示框触发的条件(mousemove|click|none)
          showDelay: 0, //浮层显示的延迟，单位为 ms，默认没有延迟，也不建议设置。在 triggerOn 为 'mousemove' 时有效。
          textStyle: {
            color: 'white',
            fontSize: 12,
          },
          padding: 0,
          position: function (pt) {
            let X = pt[0];
            let Y = pt[1];
            return [X + 10, Y + 10];
          },

          hideDelay: 10,
          backgroundColor: 'rgba(0,0,0,0)', //提示框浮层的背景颜色。
          borderColor: 'rgba(0,0,0,0)', //图形的描边颜色
          borderWidth: 1,
          alwaysShowContent: true,
          transitionDuration: 1,
        },
        geo: [
          {
            map: 'sichuan',
            aspectScale: 1, //用于 scale 地图的长宽比
            zoom: 0.84,
            layoutCenter: ['50%', '50%'], //定义地图中心在屏幕中的位置
            layoutSize: '90%', //地图的大小
            show: true, //是否显示地理坐标系组件。
            roam: false, //是否开启鼠标缩放和平移漫游。默认不开启。如果只想要开启缩放或者平移，可以设置成 'scale' 或者 'move'。设置成 true 为都开启
            label: {
              //图形上的文本标签
              show: true,
              color: '#fff',
              // borderColor: '#00EEFF',
              align: 'center',
              borderRadius: 2,
              borderWidth: 1,
              formatter: function (params) {
                const name = params.name;
                // 对特定地区应用不同样式
                if (name) {
                  return `{b|${name}}`; // 长名称使用不同样式
                }
              },
              rich: {
                b: {
                  color: '#fff',
                  // backgroundColor: {
                  //   image: require('../../../public/home/cityName.svg'),
                  // },
                  fontSize: 14,
                  height: 18,
                  lineHeight: 18,
                  align: 'center',
                },
              },
            },
            tooltip: {
              show: true, //是否显示提示框组件，包括提示框浮层和 axisPointer。
              trigger: 'item', //触发类型。item,axis,none
              enterable: true, //鼠标是否可进入提示框浮层中，默认为false，
              showContent: true, //是否显示提示框浮层
              triggerOn: 'click', //提示框触发的条件(mousemove|click|none)
              showDelay: 0, //浮层显示的延迟，单位为 ms，默认没有延迟，也不建议设置。在 triggerOn 为 'mousemove' 时有效。
              textStyle: {
                color: 'white',
                fontSize: 12,
              },
              padding: 0,
              position: function (pt, params, dom, rect, size) {
                if (params.componentSubType == 'effectScatter') {
                  return ['10%', '-11%'];
                } else {
                  let X = pt[0];
                  // 提示框的宽度和高度
                  const tooltipHeight = size.contentSize[1];
                  const tooltipWidth = size.contentSize[0];
                  // 可视区域的宽度和高度
                  const viewHeight = size.viewSize[1];
                  const viewWidth = size.viewSize[0];
                  if (X + tooltipWidth > viewWidth) {
                    X = pt[0] - tooltipWidth - 10; // 向上弹出，并留10px间距
                  } else {
                    X += 10; // 正常情况向下偏移10px
                  }
                  // 计算y坐标 - 如果下方空间不足则向上弹出
                  let Y = pt[1];
                  if (Y + tooltipHeight > viewHeight) {
                    Y = pt[1] - tooltipHeight - 10; // 向上弹出，并留10px间距
                  } else {
                    Y += 10; // 正常情况向下偏移10px
                  }
                  return [X + 10, Y + 10];
                }
              },
              formatter: function (params) {
                // 如果是 marker 聚合图标，则阻止默认行为
                if (params.componentType === 'series') {
                  return false; // 阻止默认点击行为
                }
                return `<div style="width: 200px;height: 300px" id="cardBox"/>`;
              },
              hideDelay: 10,
              backgroundColor: 'rgba(0,0,0,0)', //提示框浮层的背景颜色。
              borderColor: 'rgba(0,0,0,0)', //图形的描边颜色
              borderWidth: 1,
              alwaysShowContent: true,
              transitionDuration: 1,
            },
            itemStyle: {
              //地图区域的颜色
              areaColor: {
                type: 'linear',
                x: 5,
                y: 210,
                x2: 65,
                y2: 10,
                colorStops: [
                  {
                    offset: 0,
                    color: '#0028AD',
                  },
                  {
                    offset: 1,
                    color: '#0061E8',
                  },
                ],
                global: true, // 缺省为 false
              },
              borderColor: '#2FF1FF',
              borderWidth: 1,
            },
            //高亮状态下的多边形和标签样式
            emphasis: {
              itemStyle: {
                show: false,
                color: '#fff',
                shadowBlur: 10, // 阴影模糊大小
                shadowColor: 'rgba(0, 0, 0, 0.7)', // 阴影颜色
                shadowOffsetX: 0, // 阴影X偏移
                shadowOffsetY: 10, // 阴影Y偏移（产生上浮效果）
                borderWidth: 3, // 边框加粗
                areaColor: {
                  type: 'linear',
                  x: 100,
                  y: 100,
                  x2: 400,
                  y2: 400,
                  colorStops: [
                    { offset: 0, color: '#00B3FF' },
                    { offset: 1, color: '#00FFC8' },
                  ],
                  global: true, // 缺省为 false
                },
              },
              label: {
                show: true,
                color: '#fff',
              },
            },
          },
          //重影
          {
            type: 'map',
            map: 'sichuan',
            zlevel: -1,
            aspectScale: 1,
            zoom: 0.84,
            layoutCenter: ['50%', '51%'],
            layoutSize: '120%',
            roam: false,
            silent: true,
            itemStyle: {
              borderWidth: 1,
              borderColor: 'rgba(58,149,253,0.8)',
              // shadowColor: 'rgba(172, 122, 255,0.5)',
              shadowOffsetY: 5,
              shadowBlur: 15,
              areaColor: '#00FFEE',
            },
          },
          {
            type: 'map',
            map: 'sichuan',
            zlevel: -2,
            aspectScale: 1,
            zoom: 0.84,
            layoutCenter: ['50%', '52%'],
            layoutSize: '120%',
            roam: false,
            silent: true,
            itemStyle: {
              borderWidth: 1,
              borderColor: 'rgba(58,149,253,0.6)',
              // shadowColor: 'rgba(65, 214, 255,0.6)',
              shadowOffsetY: 5,
              shadowBlur: 15,
              areaColor: '#00AEFF',
            },
          },
          {
            type: 'map',
            map: 'sichuan',
            zlevel: -3,
            aspectScale: 1,
            zoom: 0.84,
            layoutCenter: ['50%', '53%'],
            layoutSize: '80%',
            roam: false,
            silent: true,
            itemStyle: {
              borderWidth: 1,
              borderColor: 'rgba(58,149,253,0.4)',
              // shadowColor: 'rgba(29, 111, 165,1)',
              shadowOffsetY: 15,
              shadowBlur: 10,
              areaColor: '#1C48C9',
            },
          },
          {
            type: 'map',
            map: 'sichuan',
            zlevel: -4,
            aspectScale: 1,
            zoom: 0.84,
            layoutCenter: ['50%', '54%'],
            layoutSize: '100%',
            roam: false,
            silent: true,
            itemStyle: {
              borderWidth: 5,
              borderColor: 'rgba(5,9,57,0.8)',
              // shadowColor: 'rgba(29, 111, 165,0.8)',
              shadowOffsetY: 15,
              shadowBlur: 10,
              areaColor: '#11278C',
            },
          },
        ],
        //定义图标的具体数据和类型
        series: [
          {
            type: 'effectScatter', //带有涟漪特效的动画散点
            zlevel: 3,
            coordinateSystem: 'geo', //使用的坐标系
            emphasis: {
              //高亮的图形样式和标签样式
              label: {
                show: true,
                position: 'top',
                color: '#fff',
                formatter: '{b|{b}}',
                rich: {}, //自定义富文本样式。利用富文本样式，可以在标签中做出非常丰富的效果
              },
            },
            label: {
              show: true,
              position: 'top',
              color: '#fff',
              rich: {}, //自定义富文本样式。利用富文本样式，可以在标签中做出非常丰富的效果
            },
            data: [],
            symbol: 'circle',
            symbolSize: [10, 5], //特效图形标记大小
            itemStyle: {
              color: 'orange',
              shadowBlur: 5,
              shadowColor: 'orange',
            },
            effectType: 'ripple', //特效类型，只有 ripple（涟漪）
            showEffectOn: 'render', //配置何时显示特效。可选参数 render（绘制完成后）、emphasis（高亮时）
            rippleEffect: {
              scale: 5, //波纹最大缩放比例
              brushType: 'stroke', //波纹绘制方式，可选 stroke、fill
            },
          },
        ],
      },
      // 从阿里dataV数据库直接获取指定区域的geojson地图数据
      publicUrl:
        process.env.VUE_APP_BASE_URL + '/third/api/geo/datav/areas_v3/bound/',
      level: 0,
      historyData: [],
      adName: '四川省',
      alladcode: '',
      resData: [],
      siChuanAreaData: '',
      currentHighlightIndex: -1, // 当前高亮点位索引
      isHoveringPoint: false, // 是否悬停在点位上
      showCompanyList: false, // 控制企业列表显示
      currentData: [], // 存储当前点位数据
      currentDataList: [], // 存储当前企业合集数据
      choseComponyName: '',
      removeFunction: null,
    };
  },
  mounted() {
    this.getPointLists();
    myChartMap = this.$echarts.init(document.getElementById('myMap'));
    myChartMap.showLoading({
      text: '加载中...',
      textColor: '#fff',
      color: '#fff',
      maskColor: 'rgba(0 ,0 ,0 ,0.3 )',
      zlevel: 0,
    });
    // 初始化echarts地图
    this.initChart();
    // 全局移除函数，用于在echarts图层移除dom节点
    this.removeFunction = (e) => {
      // 1. 找到视频元素并停止播放
      const videoElement = e.parentNode.parentNode.parentNode
        .closest('div')
        .querySelector('video');
      if (videoElement) {
        videoElement.pause();
        videoElement.currentTime = 0;
      }
      e.parentNode.parentNode.parentNode.style.display = 'none';
      this.choseComponyName = '';
    };
    window.remove = this.removeFunction;
    // echarts图层自适应屏幕
    // window.addEventListener('resize', function () {
    //   myChartMap.resize();
    // });
  },
  watch: {
    '$store.state.echartsMap.timeRange': {
      handler: function (val) {
        if (this.level < 2) {
          this.getPointLists();
        } else {
          // 轮播展示的城市数据
          let geoJson = this.historyData[this.historyData.length - 1].geoJson;
          let name = this.historyData[this.historyData.length - 1].name;
          let type = this.$store.state.echartsMap.dataType == 1 ? '' : 1030; //1030省社,1031全省
          getPointList({ type }).then((res) => {
            if (res.code === 200) {
              this.mapPointArr = res.data;
              this.resData = res.data;
            } else {
              this.mapPointArr = [];
              this.resData = [];
            }
            this.formatChart(geoJson, name);
          });
        }

        let glanceType = this.$store.state.echartsMap.glanceType;
        let tempDataList;
        let serseObj = {
          type: 'scatter',
          coordinateSystem: 'geo',
          zlevel: 2,
          rippleEffect: {
            period: 4,
            brushType: 'stroke',
            scale: 4,
          },
          label: {
            show: true,
            color: '#fff',
          },
          symbol: 'pin', //定位图标样式
          symbolSize: 50,
          symbolOffset: [0, -5],
          //点的名称和经纬度
          data: [],
        };
        if (!glanceType?.typeCode) {
          this.$set(serseObj, 'data', []);
          myChartMap.setOption({
            series: [serseObj],
          });
        } else {
          let type = this.$store.state.echartsMap.dataType == 1 ? 1031 : 1030; //1030省社,1031全省
          // 获取当前点击区域的adcode
          let clickRegionCode = this.alladcode.filter(
            (areaJson) =>
              areaJson.name === this.$store.state.echartsMap.cityName,
          )[0].adcode;
          // 获取站点信息
          getStatiosTypedata(glanceType.id, glanceType.typeValue, {
            type,
            adcode: clickRegionCode,
            timestr: this.$store.state.echartsMap.timeRange[0],
            quarter: this.$store.state.echartsMap.timeRange[1],
          }).then((res) => {
            if (res.code == 200) {
              tempDataList = res.data.typeCountData;
              let glanceType = this.$store.state.echartsMap.glanceType;
              // 向左侧数据概览传递最新数据，避免接口反复请求
              this.$bus.$emit(
                'typeDataMaterialData',
                res.data.typeDataMaterialData,
              );
              let data = [];
              // 包含所有城市中心点数据的数组
              centroidList.forEach((item) => {
                // 当前需要被展示在地图上的数据
                tempDataList.forEach((temp) => {
                  if (
                    item.adcode == temp.adcode &&
                    temp[glanceType.key] !== 0
                  ) {
                    data.push({
                      itemStyle: { color: '#041b68' },
                      label: {
                        formatter: (parmars) => {
                          return parmars.data.count;
                        },
                      },
                      adcode: temp.adcode,
                      count: temp[glanceType.key],
                      name: item.name,
                      value: item.centroid,
                    });
                  }
                });
              });
              // 过滤出当前城市下的二级城市网点信息进行网点撒点展示
              console.log(clickRegionCode, data);
              data = this.filter(clickRegionCode, allCentrids, data);
              this.$set(serseObj, 'data', data);
              myChartMap.setOption({
                series: [serseObj],
              });
            }
          });
        }
      },
    },
    '$store.state.echartsMap.dataType': {
      handler: function (val) {
        this.optionMap.series[0].data = null;
        this.level = 0;
        this.resData = [];
        this.currentData = [];
        this.historyData.length = 1;
        this.$store.state.echartsMap.cityName = '四川省';
        let geoJson = this.historyData[this.historyData.length - 1].geoJson;
        let name = this.historyData[this.historyData.length - 1].name;
        this.formatChart(geoJson, name);
        this.getPointLists();
        return;
      },
    },
    '$store.state.echartsMap.glanceType': {
      handler: function (val) {
        if (this.level >= 2) return;
        let tempDataList;
        let serseObj = {
          type: 'scatter',
          coordinateSystem: 'geo',
          zlevel: 2,
          rippleEffect: {
            period: 4,
            brushType: 'stroke',
            scale: 4,
          },
          label: {
            show: true,
            color: '#fff',
          },
          symbol: 'pin', //定位图标样式
          symbolSize: 50,
          symbolOffset: [0, -5],
          //点的名称和经纬度
          data: [],
        };
        if (!val) {
          this.$set(serseObj, 'data', []);
          myChartMap.setOption({
            series: [serseObj],
          });
        } else {
          let type = this.$store.state.echartsMap.dataType == 1 ? 1031 : 1030; //1030省社,1031全省
          // 获取当前点击区域的adcode
          let clickRegionCode = this.alladcode.filter(
            (areaJson) =>
              areaJson.name === this.$store.state.echartsMap.cityName,
          )[0].adcode;
          getStatiosTypedata(val.id, val.typeValue, {
            type,
            adcode: clickRegionCode,
            timestr: this.$store.state.echartsMap.timeRange[0],
            quarter: this.$store.state.echartsMap.timeRange[1],
          }).then((res) => {
            if (res.code == 200) {
              tempDataList = res.data.typeCountData;
              let data = [];
              // 包含所有城市中心点数据的数组
              centroidList.forEach((item) => {
                // 当前需要被展示在地图上的数据
                tempDataList.forEach((temp) => {
                  if (item.adcode == temp.adcode && temp[val.key] !== 0) {
                    data.push({
                      itemStyle: { color: '#041b68' },
                      label: {
                        formatter: (parmars) => {
                          return parmars.data.count;
                        },
                      },
                      adcode: temp.adcode,
                      count: temp[val.key],
                      name: item.name,
                      value: item.centroid,
                    });
                  }
                });
              });
              // 过滤出当前城市下的二级城市网点信息进行网点撒点展示
              data = this.filter(clickRegionCode, allCentrids, data);
              this.$set(serseObj, 'data', data);
              myChartMap.setOption({
                series: [serseObj],
              });
            }
          });
        }
      },
    },
    level: {
      handler: function (val) {
        this.$store.commit('echartsMap/changeMapLevel', val);
      },
    },
  },
  methods: {
    /**
     * 根据adcode筛选数据
     * @param {string} adcode - 要筛选的adcode
     * @param {Array} allCentrids - 附件1的数据
     * @param {Array} data - 附件2的数据
     * @returns {Array} 匹配到的数据数组
     */
    filter(adcode, allCentrids, data) {
      if (!allCentrids.length || !Array.isArray(allCentrids)) {
        console.error('allCentrids 参数无效:', allCentrids);
        return [];
      }
      let result = [];
      allCentrids.forEach((item) => {
        if (!item) return;
        if (item.adcode == adcode) {
          if (item.districts && Array.isArray(item.districts)) {
            item.districts.forEach((district) => {
              data.forEach((temp) => {
                if (district.adcode == temp.adcode) {
                  result.push(temp);
                }
              });
            });
          }
        } else {
          if (item.districts && Array.isArray(item.districts)) {
            const nestedResults = this.filter(adcode, item.districts, data);
            result = result.concat(nestedResults);
          }
        }
      });
      return result;
    },
    // 切换企业列表显示状态
    toggleCompanyList() {
      this.showCompanyList = !this.showCompanyList;
    },
    // 显示企业详情
    showCompanyDetail(company) {
      this.choseComponyName = company.name;
      const cardBox = document.getElementById('cardBox');
      const componyCard = document.getElementById('componyCard');
      if (cardBox) {
        console.log(cardBox, 'cardBoxcardBox');
        cardBox.remove();
      }
      if (componyCard) {
        console.log(componyCard, 'componyCardcomponyCard');
        componyCard.remove();
      }
      // 创建DOM元素并插入到页面
      const dom = document.createElement('div');
      dom.id = 'componyCard';
      dom.style.width = '600px';
      dom.style.color = '#fff';
      dom.style.position = 'absolute';
      dom.style.left = '44.8%';
      dom.style.top = '60%';
      dom.style.transform = 'translate(-50%, -50%)';
      dom.style.zIndex = '9999';
      dom.innerHTML = dom2;
      document.body.appendChild(dom);

      let src = null;
      let localUrl = process.env.VUE_APP_BASE_URL;

      if (
        Store.state.echartsMap.cityName == '郫都区' &&
        company.name == '四川中鑫凯盛再生资源有限公司'
      ) {
        src = `${localUrl}/files/video/zhongxinkaisheng.mp4`;
      } else if (
        Store.state.echartsMap.cityName == '通川区' &&
        company.name == '达州市新远达实业有限公司'
      ) {
        src = `${localUrl}/files/video/dazhouxinyuanda.mp4`;
      } else if (
        Store.state.echartsMap.cityName == '东坡区' &&
        company.name == '四川省中明再生资源综合利用有限公司'
      ) {
        src = `${localUrl}/files/video/zhongmingzaisheng.mp4`;
      } else if (
        Store.state.echartsMap.cityName == '青羊区' &&
        company.name == '爱博绿两网融合便民交投点'
      ) {
        src = `${localUrl}/files/video/aibolv.mp4`;
      } else if (
        Store.state.echartsMap.cityName == '青羊区' &&
        company.name == '青羊区文家街道文兴东路两网融合便民交投点'
      ) {
        src = `${localUrl}/files/video/wenjiajiedao.mp4`;
      } else if (
        Store.state.echartsMap.cityName == '金堂县' &&
        company.name == '成都嘉汉达环保科技有限公司'
      ) {
        src = `${localUrl}/files/video/chengdujiahanda.mp4`;
      } else if (
        Store.state.echartsMap.cityName == '涪城区' &&
        company.name == '绵阳市增强再生资源回收利用有限责任公司'
      ) {
        src = `${localUrl}/files/video/zengqiangzaisheng.mp4`;
      } else if (
        Store.state.echartsMap.cityName == '翠屏区' &&
        company.name == '宜宾市翠屏区桂乐供销再生资源有限责任公司'
      ) {
        src = `${localUrl}/files/video/guilegongxiao.mp4`;
      }
      console.log(
        company.name,
        Store.state.echartsMap.cityName,
        'xxxxxxxxxxxxxxxx',
      );
      // 获取video元素
      const video = document.querySelector('video'); // 或 document.getElementById('videoId')
      if (video) video.innerHTML = `<source src="${src}" type="video/mp4">`;

      // 填充企业数据
      const componyName = dom.querySelector('#componyName');
      const legalPerson = dom.querySelector('#legalPerson');
      const contact = dom.querySelector('#contact');
      const address = dom.querySelector('#address');
      componyName.innerText = company.name;
      legalPerson.innerText = company.linkman || '';
      contact.innerText = company.cellPhone || '';
      address.innerText = company.address;
      this.initPieChart(company)
      // 添加关闭事件
      const closeBtn = dom.querySelector('img[onclick="remove(this)"]');
      closeBtn.onclick = () => {
        document.body.removeChild(dom);
        this.choseComponyName = '';
      };
    },
    getComponyInfo(params) {
      console.log(params, 'paramsparamsparams');
      const componyName = document.getElementById('componyName');
      const legalPerson = document.getElementById('legalPerson');
      const contact = document.getElementById('contact');
      const address = document.getElementById('address');
      componyName.innerText = params.data.name;
      legalPerson.innerText = params.data.linkman;
      contact.innerText = params.data.cellPhone;
      address.innerText = params.data.address;
    },
    getPointLists() {
      //此处获取后端接口返回数据
      // 轮播展示的城市数据
      let type = this.$store.state.echartsMap.dataType == 1 ? 1031 : 1030; //1030省社,1031全省
      getPointList({ type }).then((res) => {
        if (res.code === 200) {
          this.mapPointArr = res.data;
          console.log(this.mapPointArr, '全量点位获取');
        } else {
          this.mapPointArr = [];
        }
      });
    },
    getCityStations(params) {
      let adCode = this.alladcode.filter(
        (areaJson) => areaJson.name === params.name,
      )[0].adcode;
      console.log(adCode, 'adCodeadCodeadCode');
      let type = this.$store.state.echartsMap.dataType == 1 ? 1031 : 1030; //1030省社,1031全省
      let data = {
        type: type,
        timestr: this.$store.state.echartsMap.timeRange[0],
        quarter: this.$store.state.echartsMap.timeRange[1],
      };
      const recycleStation = document.getElementById('recycleStation');
      const transferStation = document.getElementById('transferStation');
      const sortingCenter = document.getElementById('sortingCenter');
      const dismantlingCenter = document.getElementById('dismantlingCenter');
      const industrialPark = document.getElementById('industrialPark');
      const wasteEnterprise = document.getElementById('wasteEnterprise');
      const tradingMarket = document.getElementById('tradingMarket');
      const domEchartsMap = document.getElementById('echartsMap');
      const cityName = document.getElementById('cityName');
      getAmountOfDismantling(adCode, data).then((res) => {
        if (res.code == 200) {
          recycleStation.innerText = res.data?.recycleStation
            ? res.data?.recycleStation
            : 0;
          transferStation.innerText = res.data?.transferStation
            ? res.data?.transferStation
            : 0;
          sortingCenter.innerText = res.data?.sortingCenter
            ? res.data?.sortingCenter
            : 0;
          dismantlingCenter.innerText = res.data?.dismantlingCenter
            ? res.data?.dismantlingCenter
            : 0;
          industrialPark.innerText = res.data?.industrialPark
            ? res.data?.industrialPark
            : 0;
          wasteEnterprise.innerText = res.data?.wasteEnterprise
            ? res.data?.wasteEnterprise
            : 0;
          cityName.innerText = params.name;
        }
      });
    },
    // 南沙诸岛以缩略图展示
    async formatJson(chinaGeoJson) {
      chinaGeoJson.features.forEach((v) => {
        if (v.properties && v.properties.name == '海南省') {
          v.geometry.coordinates = v.geometry.coordinates.slice(0, 1);
        }
      });
      // 过滤掉海南诸岛边界线
      chinaGeoJson.features = chinaGeoJson.features.filter(
        (item) => item.properties.adcode !== '100000_JD',
      );
      return chinaGeoJson;
    },
    // 初始化
    async initChart() {
      // 获取地图name对应的adcode行政区划编码
      let geoJson = allAdcode;
      this.alladcode = geoJson;
      window.alladcode = geoJson;
      // 获取datav在线的四川省地图
      let areaJsonName = '510000_full.json';
      let chinaGeoJson = require(`./json/areaGeojson/${areaJsonName}`);
      let formatChinaGeoJson = await this.formatJson(chinaGeoJson);
      // 鼠标移入点位的弹窗
      let rich = {
        b: {
          color: '#fff',
          backgroundColor: {
            image: require('../../../public/home/point.png'),
          },
          padding: [20, 30],
          fontSize: 14,
          align: 'center',
        },
      };
      this.optionMap.series[0].emphasis.label.rich = rich;
      this.optionMap.series[0].label.rich = rich;
      this.initEcharts(formatChinaGeoJson, '四川省');
    },
    //echarts绘图
    initEcharts(geoJson, name) {
      this.formatChart(geoJson, name);
      myChartMap.hideLoading();
      window.addEventListener('resize', () => {
        myChartMap.resize();
      });
      this.historyData.push({ geoJson, name });
      console.log(
        this.historyData,
        'this.historyDatathis.historyDatathis.historyData',
      );
      myChartMap.off('dblclick');
      myChartMap.on('dblclick', (params) => {
        // 如果是 marker 聚合图标，则阻止默认行为
        if (params.componentType === 'series') {
          return false; // 阻止默认点击行为
        }
        if (this.level >= 2) return;
        this.level++;
        this.$store.state.echartsMap.cityName = params.name;
        if (this.level > 1) {
          //此处获取后端接口返回数据
          // 轮播展示的城市数据
          this.resData = this.mapPointArr;
        }
        this.$store.commit('echartsMap/changeGlanceType', undefined);
        // 点击的是当前地图
        if (params.componentType != 'geo') return;
        // 获取当前点击区域的adcode
        let clickRegionCode = this.alladcode.filter(
          (areaJson) => areaJson.name === params.name,
        )[0].adcode;
        console.log(clickRegionCode, 'clickRegionCode');
        // 没有区县的地级市,东莞,中山,儋州,三沙,嘉峪关
        let adcodeArr = ['460400', '460300', '441900', '442000', '620200'];
        let areaName;
        let regionGeoJson = [];
        // 区县或者没有区县的地级市
        if (
          clickRegionCode.toString().slice(-2) != '00' ||
          adcodeArr.includes(clickRegionCode.toString())
        ) {
          console.log(this.historyData, 'historyData');
          // 通过缓存的城市名称层级数据关系，确定当点击到第三层图层后，父级的城市名（用于规避类似于’市中区‘有多个城区名字相同的情况）
          let parentName = this.historyData[this.historyData.length - 1].name;
          let parentAreaInfo = allAdcode.filter((item) => {
            if (item.name == parentName) {
              return item;
            }
          });
          // 获取父级adcode对应的geojson离线文件
          areaName = `${parentAreaInfo[0].adcode}_full.json`;
          let areaGeojson = require(`./json/areaGeojson/${areaName}`);
          // 循环父级geojson离线文件，获取包含当前点击区域的geojson离线数据
          let features = areaGeojson.features;
          for (let i = 0; i < features.length; i++) {
            // 如果父级文件中的城市名与当前点击城市名一致，则获取geojson渲染第三层数据
            if (features[i].properties.name == params.name) {
              regionGeoJson = features[i];
              regionGeoJson = {
                type: 'FeatureCollection',
                features: [regionGeoJson],
              };
            }
          }
        } else {
          areaName = `${clickRegionCode}_full.json`;
          regionGeoJson = require(`./json/areaGeojson/${areaName}`);
        }
        this.initEcharts(regionGeoJson, params.name);
      });
      myChartMap.off('click');
      myChartMap.on('click', (params) => {
        // 如果是 marker 聚合图标，则阻止默认行为
        if (params.componentType === 'series') {
          return false; // 阻止默认点击行为
        }
        console.log(Store.state.echartsMap.cityName, params);
        this.choseComponyName = params.name;
        const cardBox = document.getElementById('cardBox');
        if (this.level == 2 && params.componentSubType == 'effectScatter') {
          console.log(params, 'paramsparams');
          // cardBox.innerHTML = dom2;
          this.showCompanyDetail(params.data);
        } else if (this.level == 0 || this.level == 1) {
          cardBox.innerHTML = dom1;
        } else {
          cardBox.innerHTML = ``;
          cardBox.style.display = 'none';
        }

        if (params.componentSubType !== 'effectScatter') {
          this.getCityStations(params);
        } else {
          this.getComponyInfo(params);
        }
      });

      // 添加鼠标移入移出事件
      myChartMap.off('mouseover');
      myChartMap.off('mouseout');
      myChartMap.on('mouseover', (params) => {
        if (params.componentSubType === 'effectScatter') {
          this.isHoveringPoint = true;
          // 停止轮播
          if (charTimer) {
            clearInterval(charTimer);
            charTimer = null;
          }
          // 高亮当前点位
          this.currentHighlightIndex = this.optionMap.series[0].data.findIndex(
            (item) => item.name === params.name,
          );
          this.highLightPoint(
            this.optionMap.series[0].data,
            this.currentHighlightIndex,
          );
          myChartMap.setOption(this.optionMap);
        }
      });
      myChartMap.on('mouseout', (params) => {
        if (params.componentSubType === 'effectScatter') {
          this.isHoveringPoint = false;
          this.currentHighlightIndex = -1;
          // 恢复轮播
          this.startPointCarousel();
        }
      });
    },
    // 点位颜色高亮
    highLightPoint(currentData, index) {
      currentData.forEach((v, key) => {
        let flag = key == index ? 'aqua' : 'orange';
        v.itemStyle = {
          color: flag,
          shadowColor: flag,
        };
      });
      this.optionMap.series[0].label.formatter = (e) => {
        return e.name === currentData[index].name ? `{b|${e.name}}` : '';
      };
    },
    // 启动点位轮播
    startPointCarousel() {
      if (charTimer) {
        clearInterval(charTimer);
        charTimer = null;
      }

      this.currentData = this.optionMap.series[0].data;
      // 点位大于2个才循环轮播
      if (this.currentData.length > 1) {
        let i =
          this.currentHighlightIndex >= 0 ? this.currentHighlightIndex : 0;
        charTimer = setInterval(() => {
          if (this.isHoveringPoint) return; // 如果鼠标在点位上，不执行轮播

          i++;
          if (i >= this.currentData.length) i = 0;
          this.highLightPoint(this.currentData, i);
          myChartMap.setOption(this.optionMap);
        }, 1000 * 3);
      }
    },
    // 格式图表
    formatChart(geoJson, name) {
      this.$store.state.echartsMap.isLower = false;
      // 过滤出当前地图的点位
      this.currentData = this.resData?.filter((v) => {
        return isPointInMultiPolygon(
          [v.locationDc[0], v.locationDc[1]],
          geoJson.features,
        );
      });
      // 当前展示地图所属区域
      this.adName = name == 'sichuan' ? '四川省' : name;

      this.$echarts.registerMap(name, geoJson);
      this.optionMap.geo.forEach((v) => {
        v.map = name;
        console.log(name, 'namenamename');
        v.layoutSize = cityScale[name] || '100%';
      });
      this.currentData.forEach((item) => {
        item.value = item.locationDc;
      });
      this.currentDataList = this.currentData;
      this.optionMap.series[0].data = this.currentData;
      // 点位颜色高亮
      this.highLightPoint(this.currentData, 0);
      this.optionMap.series[0].label.show = true;
      myChartMap.clear();
      myChartMap.setOption(this.optionMap);

      // 启动轮播
      this.startPointCarousel();
    },
    // 返回上一级
    upside() {
      if (this.historyData.length > 1) {
        this.$store.commit('echartsMap/changeGlanceType', undefined);
        this.historyData.pop();
        let upData = this.historyData[this.level - 1];
        console.log();
        this.resData = [];
        this.currentDataList = [];
        this.$store.state.echartsMap.cityName = this.historyData.name
          ? this.historyData.name
          : '四川省';
        this.formatChart(upData.geoJson, upData.name);
        this.level--;
      }
      this.$store.state.echartsMap.cityName =
        this.historyData[this.historyData.length - 1].name;
    },
    /**
     * 递归处理地理坐标数据
     * @param {Array} coords - 坐标数据
     * @param {Function} callback - 对每个坐标点的处理函数
     */
    processCoordinates(coords, callback) {
      if (Array.isArray(coords[0]) && typeof coords[0][0] === 'number') {
        // 简单坐标数组 [[lng,lat], [lng,lat], ...]
        coords.forEach((coord) => callback(coord));
      } else if (Array.isArray(coords[0])) {
        // 嵌套坐标数组 [[[lng,lat], [lng,lat], ...], ...]
        coords.forEach((subCoords) =>
          this.processCoordinates(subCoords, callback),
        );
      }
    },
    // 初始化饼图
    initPieChart(company) {
      // 解析ratio数据
      let ratioData = [];
      try {
        if (company.ratio) {
          ratioData = JSON.parse(company.ratio);
        }
      } catch (e) {
        console.error('解析股份占比数据失败:', e);
        ratioData = [];
      }

      // 转换数据格式为ECharts所需格式
      const chartData = ratioData.map((item) => ({
        name: item.Shareholder,
        value: Number(item.ratio.replace('%', '')), // 去除百分号，只保留数字
      }));
      let otherValue = 0;
      chartData.forEach((item) => {
        otherValue += item.value;
      });
      if (otherValue < 100 && otherValue > 0) {
        chartData.push({
          name: '其他',
          value: 100 - otherValue,
        });
      }
      console.log(chartData, 'chartData');
      // 获取DOM容器并初始化图表
      const pieContainer = document.getElementById('SharesPie');
      if (this.pieChart) {
        this.pieChart.dispose(); // 销毁已有实例
      }
      this.pieChart = echarts.init(pieContainer);

      // 字符串截断工具函数：超过maxLength则截断并加省略号
      function truncateText(text, maxLength = 7) {
        if (typeof text !== 'string') return text;
        return text.length > maxLength
            ? text.slice(0, maxLength) + '...'
            : text;
      }

      // 饼图配置
      const option = {
        tooltip: {
          trigger: 'item',
          // tooltip显示完整文字（不截断）
          formatter: (params) =>
              `${params.seriesName}<br/>${params.name}: ${params.percent}%`,
        },
        legend: {
          orient: 'horizontal',
          show:false,
          bottom: 0,
          textStyle: {
            fontSize: 14,
          },
          padding: [10, 0, 0, 0],
          // 图例文字截断处理
          formatter: (name) => truncateText(name),
          // 禁用图例点击能力
          selectedMode: false, // 关键配置：设为false则无法点击切换系列显示状态
        },
        series: [
          {
            name: '占有比例',
            type: 'pie',
            center: ['50%', '50%'],
            radius: ['40%', '65%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: 'bold',
                // 鼠标 hover 时显示完整文字
                formatter: (params) => `${params.name}: ${params.percent}%`,
              },
            },
            // 饼图外侧标签文字截断处理
            label: {
              show: true,
              position: 'outside',
              formatter: (params) =>
                  `${truncateText(params.name)}: ${params.percent}%`,
              fontSize: 14,
              color: '#ffffff',
              lineStyle: {
                color: '#999',
                width: 1,
              },
            },
            labelLine: {
              show: true,
              length: 15,
              length2: 20,
              smooth: false,
            },
            data: chartData,
          },
        ],
      };

      // 设置图表选项
      this.pieChart.setOption(option);

      // 监听窗口大小变化，调整图表尺寸
      window.addEventListener('resize', this.handleResize);
    },
    // 处理窗口大小变化
    handleResize() {
      if (this.pieChart) {
        this.pieChart.resize();
      }
    },
  },
  destroyed() {
    if (myChartMap) myChartMap.clear();
    if (charTimer) {
      clearInterval(charTimer);
      charTimer = null;
    }
  },
};
</script>
<style scoped lang="less">
.about {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
#myMap {
  width: 100%;
  height: 100%;
  margin: 0 auto; /* 水平居中 */
}
.btn {
  position: absolute;
  top: 0px;
  right: 10px;
  font-size: 30px;
}
.Tooltip {
  position: absolute;
  bottom: 0px;
  right: 0px;
}
.map-point {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100px;
  height: 100px;
  //background: url('~@/assets/recycling/bg4.jpg') no-repeat;
  background-size: 100%;
  display: none;
}
/* 新增企业列表样式 */
.company-list-icon {
  position: absolute;
  top: 60px;
  right: 10px;
  width: 122px;
  height: 45px;
  border-radius: 3px;
  background-color: #409eff;
  cursor: pointer;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    color: #ffffff;
    font-size: 26px;
    font-weight: 600;
  }
}

.company-list-container {
  position: absolute;
  top: 58px;
  right: 10px;
  width: 250px;
  max-height: 300px;
  background: rgba(8, 58, 109, 0.5);
  //box-shadow: inset 2px 2px 10px #1AFFFB, 4px 4px 16px #002740;
  backdrop-filter: blur(4px);
  border-radius: 5px;
  z-index: 100;
  overflow: hidden;

  .company-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background: rgba(0, 167, 255, 0.1);

    span {
      font-size: 18px;
      color: #fff;
    }

    img {
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }

  .company-list-content {
    overflow-y: auto;
    max-height: 250px;
    padding: 5px;

    .company-item {
      padding: 8px 10px;
      margin: 5px 0;
      color: #fff;
      background: rgba(0, 167, 255, 0.1);
      border-radius: 3px;
      cursor: pointer;
      transition: all 0.3s;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 16px;
      white-space: nowrap;
      &:hover {
        background: rgba(0, 167, 255, 0.3);
        transform: translateX(5px);
      }
    }
    .choseColor {
      background: rgba(0, 167, 255, 0.3);
      transform: translateX(5px);
    }
  }
}
</style>
